package com.anjuros.website.redesign.sections.designs

import androidx.compose.runtime.Composable
import com.anjuros.website.components.language.LocalText
import com.anjuros.website.redesign.components.RdRichText
import com.anjuros.website.redesign.components.RdLink
import com.anjuros.website.redesign.components.RdSection
import com.anjuros.website.redesign.components.RdSectionHead
import com.anjuros.website.redesign.styles.DesignsGuideStyle
import com.anjuros.website.redesign.styles.RdH3Style
import com.anjuros.website.redesign.styles.RdSectionFlushTopStyle
import com.anjuros.website.redesign.styles.RdSectionStyle
import com.anjuros.website.redesign.util.RdRoute
import com.anjuros.website.redesign.util.RdText
import com.anjuros.website.redesign.util.rdList
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.H3
import org.jetbrains.compose.web.dom.Li
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Text
import org.jetbrains.compose.web.dom.Ul

/** Advice on choosing a design; also the main body text for search engines. */
@Composable
fun DesignsGuideSection() {
    RdSection(
        id = "guide",
        labelledBy = "guide-h",
        modifier = RdSectionStyle.toModifier().then(RdSectionFlushTopStyle.toModifier()),
    ) {
        RdSectionHead(RdText.DESIGNS_GUIDE_EYEBROW, "guide-h", RdText.DESIGNS_GUIDE_TITLE)
        Div(DesignsGuideStyle.toModifier().toAttrs()) {
            Div {
                H3(RdH3Style.toModifier().toAttrs()) { Text(LocalText(RdText.DESIGNS_GUIDE1_TITLE)) }
                P { Text(LocalText(RdText.DESIGNS_GUIDE1_TEXT)) }
            }
            Div {
                H3(RdH3Style.toModifier().toAttrs()) { Text(LocalText(RdText.DESIGNS_GUIDE2_TITLE)) }
                Ul { rdList(LocalText(RdText.DESIGNS_GUIDE2_ITEMS)).forEach { Li { RdRichText(it) } } }
            }
            Div {
                H3(RdH3Style.toModifier().toAttrs()) { Text(LocalText(RdText.DESIGNS_GUIDE3_TITLE)) }
                P {
                    Text(LocalText(RdText.DESIGNS_GUIDE3_TEXT_START))
                    RdLink(RdRoute.PRICING) { Text(LocalText(RdText.DESIGNS_GUIDE3_LINK)) }
                    Text(LocalText(RdText.DESIGNS_GUIDE3_TEXT_END))
                }
            }
        }
    }
}
